var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_803_587)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "url(#paint0_linear_803_587)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_803_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7.78472V52.2153C11 54.3052 12.7403 55.9979 14.8846 55.9979V4C12.7403 4 11 5.69479 11 7.78472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1271 53.6951V6.30312C18.1271 5.03264 19.1872 4 20.4939 4H23.0544V25.3028C22.2168 26.0455 21.507 26.8323 20.9336 27.5462C20.5413 28.0358 20.2142 28.4885 19.9561 28.8705C19.802 29.0976 19.672 29.299 19.5677 29.4667C19.3524 29.8118 19.352 30.1865 19.5674 30.5319C19.6717 30.6993 19.8016 30.9014 19.9561 31.1295C20.2142 31.5115 20.5413 31.9642 20.9336 32.4538C21.2863 32.8931 21.6903 33.3615 22.1456 33.8278C22.4297 34.1194 22.733 34.4111 23.0544 34.6951V55.9979H20.4939C19.1872 55.9979 18.1271 54.9674 18.1271 53.6951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2973 22.992V4H26.7006V22.992C27.7136 22.5892 28.8175 22.3455 30 22.3455C31.1825 22.3455 32.2842 22.5892 33.2973 22.992Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7006 37.008V55.9979H33.2973V37.008C32.2842 37.4108 31.1807 37.6545 30 37.6545C28.8193 37.6545 27.7158 37.4108 26.7006 37.008Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9438 4H39.5061C40.8107 4 41.8711 5.03264 41.8711 6.30312V53.6951C41.8711 54.9674 40.8107 55.9979 39.5061 55.9979H36.9438V34.699C37.7793 33.9562 38.4908 33.1694 39.0643 32.4576C39.6912 31.6753 40.1532 30.9816 40.433 30.5323C40.648 30.1865 40.6476 29.8118 40.4323 29.4663C40.1525 29.0174 39.6908 28.324 39.0643 27.5424C38.4908 26.8285 37.7793 26.0417 36.9438 25.301V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1154 4V56C47.2615 56 49 54.3052 49 52.2174V7.78472C49 5.69479 47.2615 4 45.1154 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7006 28.1795C27.148 25.7826 28.4569 24.0476 30 24.0476C31.5413 24.0476 32.8481 25.7788 33.2973 28.1701C33.4059 28.7458 33.465 29.3601 33.465 29.999C33.465 30.6382 33.4059 31.2524 33.2973 31.8299C32.8481 34.2212 31.5431 35.9503 30 35.9503C28.4569 35.9503 27.148 34.2156 26.7006 31.8205C26.5923 31.2465 26.535 30.6344 26.535 29.999C26.535 29.3639 26.5923 28.7535 26.7006 28.1795Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 11.5,
    stroke: "url(#paint1_linear_803_587)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_803_587",
    x: 8,
    y: 3,
    width: 44,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_803_587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_803_587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_803_587",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1055FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_803_587",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_803_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialOffers);
export default __webpack_public_path__ + "static/media/special-offers.6a96d1e81ef78416f6a72709db784461.svg";
export { ForwardRef as ReactComponent };